import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const sections = [
  {
    number: 1,
    title: 'Хувийн мэдээлэл цуглуулах',
    paragraphs: [
      'Бид таны бүртгэл үүсгэх, үйлчилгээ үзүүлэх зорилгоор дараах мэдээллийг цуглуулна: нэр, утасны дугаар, имэйл хаяг, төлбөрийн мэдээлэл.',
      'Таны платформ дээрх үйл ажиллагаа (үзсэн сургалт, хичээл дуусгасан байдал, хандалтын бүртгэл) автоматаар бүртгэгдэнэ.',
    ],
  },
  {
    number: 2,
    title: 'Мэдээлэл ашиглалт',
    paragraphs: [
      'Таны мэдээллийг зөвхөн үйлчилгээ үзүүлэх, сайжруулах, аюулгүй байдлыг хангах зорилгоор ашиглана.',
      'Бид таны мэдээллийг таны зөвшөөрөлгүйгээр гуравдагч этгээдэд дамжуулахгүй бөгөөд зар сурталчилгааны зорилгоор ашиглахгүй.',
    ],
  },
  {
    number: 3,
    title: 'Cookie болон технологи',
    paragraphs: [
      'Бид вэбсайтын ажиллагааг сайжруулахын тулд cookie, session storage ашигладаг. Эдгээр нь таны нэвтрэлтийн төлөвийг хадгалах, хэрэглэгчийн туршлагыг тохируулахад ашиглагдана.',
      'Та хөтчийн тохиргооноос cookie-г идэвхгүй болгох боломжтой, гэхдээ зарим функц ажиллахгүй байж болно.',
    ],
  },
  {
    number: 4,
    title: 'Мэдээллийн аюулгүй байдал',
    paragraphs: [
      'Бид таны мэдээллийг хамгаалахын тулд SSL шифрлэлт, аюулгүй серверийн дэд бүтэц, нэвтрэлтийн хяналт зэрэг арга хэмжээнүүдийг авч хэрэгжүүлдэг.',
      'Мэдээллийн аюулгүй байдлын зөрчил гарсан тохиолдолд холбогдох хэрэглэгчид болон эрх бүхий байгууллагад мэдэгдэнэ.',
    ],
  },
  {
    number: 5,
    title: 'Таны эрхүүд',
    paragraphs: [
      'Та хүссэн үедээ өөрийн хувийн мэдээлэлд хандах, засварлах, устгах хүсэлт гаргах эрхтэй.',
      'Бүртгэлээ устгахыг хүсвэл тохиргоо хэсгээс эсвэл бидэнтэй шууд холбогдож хүсэлтээ илгээнэ үү.',
    ],
  },
]

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-[1024px] mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 text-sm font-medium text-gray-800 bg-white border border-gray-200 rounded-full px-4 py-2.5 shadow-md hover:bg-gray-50 transition"
          >
            <ArrowLeft className="size-5" />
            Буцах
          </Link>
        </div>
      </div>

      {/* Title */}
      <div className="text-center pt-8 pb-6">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800">НУУЦЛАЛЫН БОДЛОГО</h1>
        <p className="text-base text-gray-500 mt-3 max-w-[500px] mx-auto">
          Таны хувийн мэдээллийг бид хэрхэн цуглуулж, хадгалж, хамгаалдаг талаар.
        </p>
      </div>

      {/* Content */}
      <div className="max-w-[1024px] mx-auto px-4 pb-20">
        <div className="flex flex-col gap-8">
          {sections.map((section) => (
            <div key={section.number} className="flex flex-col gap-6">
              <div className="flex flex-col gap-6 items-end">
                <h2 className="w-full text-2xl font-medium text-gray-800">
                  <ol start={section.number} className="list-decimal pl-9">
                    <li>{section.title}</li>
                  </ol>
                </h2>
                <hr className="border-gray-200 w-full" />
                <div className="flex flex-col gap-4 w-full">
                  {section.paragraphs.map((paragraph, index) => (
                    <p key={index} className="text-lg text-gray-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
